export default {
  title: 'Herzlichen Glückwunsch! Du hast gerade {{value}} Punkte verdient 🥳',
  balance: 'Meine Punkte <highlight>{{value}}p ({{moneyValue}})</highlight>',
  description: 'Löse deine Punkte bei deiner nächsten Bestellung ein',
  guest_description:
    'Du hast <highlight>{{value}} Punkte ({{moneyValue}})</highlight> Rabatt für deine nächste Bestellung verdient! 🤩',
  buttons: {
    ok: 'Okay',
    claim: 'Login und Punkte sichern',
  },
};
